import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";
import Swal from "sweetalert2";

// Mesmos valores do CHECK constraint no banco (ver
// backend/src/models/AcervoDetentor.js e a migração), pra nunca dar 400.
export const OPCOES_TIPO_ACERVO = ["Pessoa física", "Departamento", "Instituição", "Outro"];

export default function AcervoDetentor() {
    const navigate = useNavigate();
    const { get, post, put } = useFetch();
    const location = useLocation();
    const { id } = useParams();

    const [state, setState] = useState({
        acao: location.state?.acao || (id === "criar" ? "Criar" : "Visualizar"),
        acervo: { nome: "", tipo: "Instituição", observacoes: "", status_acervo_detentor: "ativo" }
    });

    useEffect(() => {
        if (id !== "criar") {
            get("/acervodetentor/" + id).then(response => {
                if (response.ok) setState(s => ({ ...s, acervo: response.result.data }));
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({ ...prev, acervo: { ...prev.acervo, [name]: value } }));
    };

    async function salvar() {
        if (!state.acervo.nome) {
            Swal.fire({ title: "Preencha o nome do acervo", icon: "warning", confirmButtonColor: "#587b7f" });
            return;
        }

        let method = state.acao === "Criar" ? post : put;
        let url = state.acao === "Criar" ? `/acervodetentor` : `/acervodetentor/${id}`;

        try {
            let response = await method(url, state.acervo);
            if (response.ok) {
                Swal.fire({ title: "Sucesso!", text: "Acervo salvo com sucesso!", icon: "success", confirmButtonColor: "#587b7f" });
                navigate("/admin/iconografico/acervos");
            } else if (response.status === 409) {
                Swal.fire({ title: "Nome já cadastrado", text: response.result?.message ?? "Já existe um acervo com esse nome.", icon: "error", confirmButtonColor: "#587b7f" });
            } else {
                Swal.fire({ title: "Erro", text: "Erro ao salvar acervo.", icon: "error", confirmButtonColor: "#587b7f" });
            }
        } catch (error) { console.error(error); }
    }

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/iconografico/acervos" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar aos Acervos
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Acervo</h2>
                            <p className="admin-subtitle small mb-0">Acervo onde as fotografias ficam guardadas — departamento, instituto ou pessoa responsável pela guarda</p>
                        </div>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-md-8">
                                <Form.Label className="label-admin">* Nome do Acervo</Form.Label>
                                <Form.Control
                                    className="input-moderno"
                                    name="nome"
                                    placeholder="Ex: Departamento de Bioquímica..."
                                    value={state.acervo.nome ?? ""}
                                    onChange={handleChange}
                                    disabled={state.acao === "Visualizar"}
                                    maxLength={200}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Tipo</Form.Label>
                                <Form.Select
                                    className="input-moderno"
                                    name="tipo"
                                    value={state.acervo.tipo ?? ""}
                                    onChange={handleChange}
                                    disabled={state.acao === "Visualizar"}
                                >
                                    {OPCOES_TIPO_ACERVO.map((v) => <option key={v} value={v}>{v}</option>)}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Status</Form.Label>
                                <Form.Select
                                    className="input-moderno"
                                    name="status_acervo_detentor"
                                    value={state.acervo.status_acervo_detentor ?? "ativo"}
                                    onChange={handleChange}
                                    disabled={state.acao === "Visualizar"}
                                >
                                    <option value="ativo">Ativo</option>
                                    <option value="inativo">Inativo</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="col-md-12">
                                <Form.Label className="label-admin">Observações</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    className="input-moderno"
                                    name="observacoes"
                                    value={state.acervo.observacoes ?? ""}
                                    onChange={handleChange}
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvar}>
                                    <FontAwesomeIcon icon={faSave} className="me-2" /> Salvar Acervo
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}
